import { setImpersonatedUserInLocalStorage } from '../helpers/local-storage';

export default session => {
  const { userId, token, expires } = session;

  setImpersonatedUserInLocalStorage({ userId, token, expires });
  window.location.href = '/';
};
